import type { HelpFile } from '../../types/help'
import { RestrictionRuleDetailTestIds } from '../../../testids/RestrictionRuleDetailTestIds'

export const restrictionRuleDetailHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleDetailTestIds.restrictionRuleDetailPage]:
      'Restriction rule detail — configuration, denied access profiles, status, and current violations.',
    [RestrictionRuleDetailTestIds.cardRuleDetails]:
      'Core configuration: owner, status, scoping condition, and grace period.',
    [RestrictionRuleDetailTestIds.ruleInfoCard]: null,
    [RestrictionRuleDetailTestIds.sectionConditionExpression]:
      'Optional CEL expression that scopes this rule to a subset of identities — identities that do not match are not evaluated.',
    [RestrictionRuleDetailTestIds.sectionDeniedProfiles]:
      'Access profiles forbidden together by this rule — holding all listed profiles produces a violation.',
    [RestrictionRuleDetailTestIds.ruleConditionExpr]:
      'Scoping condition — when set, the rule only applies to identities matching the CEL expression.',
    [RestrictionRuleDetailTestIds.ruleGraceDays]:
      'Grace period in days — newly detected violations can be remediated within this window before escalation.',
    [RestrictionRuleDetailTestIds.ruleStatus]:
      'Activation status — active rules are evaluated continuously.',
    [RestrictionRuleDetailTestIds.badgeActive]: null,
    [RestrictionRuleDetailTestIds.badgeInactive]: null,
    [RestrictionRuleDetailTestIds.badgeViolations]:
      'Total violations recorded against this rule.',
    [RestrictionRuleDetailTestIds.badgeOpenViolations]:
      'Violations still open — not yet remediated.',
    [RestrictionRuleDetailTestIds.btnEdit]:
      'Open the change wizard to propose modifications to this restriction rule.',
    [RestrictionRuleDetailTestIds.btnTestRestrictionRule]:
      'Run the rule against current identity data — shows identities evaluated, matches, and open violations.',
    [RestrictionRuleDetailTestIds.btnActivate]:
      'Submit an activation request for this rule through the approval workflow.',
    [RestrictionRuleDetailTestIds.btnDeactivate]:
      'Submit a deactivation request for this rule through the approval workflow.',
    [RestrictionRuleDetailTestIds.dialogActivateRule]:
      'Confirmation before submitting the activation request through the approval workflow.',
    [RestrictionRuleDetailTestIds.dialogDeactivateRule]:
      'Confirmation before submitting the deactivation request through the approval workflow.',
    [RestrictionRuleDetailTestIds.openRequestBanner]:
      'A change request for this rule is currently pending.',
    [RestrictionRuleDetailTestIds.linkOpenRequest]:
      'Open the pending change request for this rule.',
    [RestrictionRuleDetailTestIds.linkViolations]:
      'Open violations filtered to this rule.',
    [RestrictionRuleDetailTestIds.colProfileCode]:
      'Code of the denied access profile.',
    [RestrictionRuleDetailTestIds.colProfileName]: null,
    [RestrictionRuleDetailTestIds.colResource]:
      'Resource the denied access profile applies to.',
    [RestrictionRuleDetailTestIds.colSystem]:
      'Target system the denied access profile applies to.',
  },
}
